<template>
  <div class="card" @click="viewCard(cardLecture.id)" :class="[ isList ? 'list' : '' ]">
    <img class="card-img-top" :src="cardImage" alt="Card image cap">
    <div v-if="isCurrentCard" class="card-state-text">{{ $t('common.during_learning') }}</div>
    <div class="card-body">
      <div class="card-title">{{ cardTitle }}</div>
      <div class="card-text-1">{{ cardPublisher }}</div>
      <div class="card-text-2">{{ cardGrade }} {{ cardSubjectName }}</div>
      <div class="card-text-3">{{ $t('common.view_count') }} {{ getFormatCount(cardViewsCount) }}</div>
      <div class="card-text-4">{{ $t('common.like_up') }} {{ getFormatCount(cardLikeCount) }}</div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { find } from 'lodash';

  import numbers from '@/mixins/numbers';
  import labels from '@/mixins/labels';

  export default {
    name: 'image-card',

    mixins: [
      numbers,
      labels,
    ],

    props: {
      cardLecture: {
        type: Object,
      },
      isList: {
        type: Boolean,
        default: false,
      },
      likeCount: {
        type: Number,
        default: 0,
      },
      isCourseCard: {
        type: Boolean,
        default: false,
      },
      courseId: {
        type: Number,
      },
      isCurrentCard: {
        type: Boolean,
        default: false,
      },
      eventLabel: {
        type: String,
        default: 'card_lecture',
      },
    },

    computed: {
      ...mapGetters({
        subjectMap: 'getSubjectMap',
        gradeMap: 'getGradeMap',
      }),

      cardTitle() {
        return this.cardLecture.title;
      },

      cardImage() {
        return this.cardLecture.cover_image_small;
      },

      cardPublisher() {
        return this.cardLecture.publisher_name;
      },

      cardLikeCount() {
        return this.likeCount || this.cardLecture.like_count;
      },

      filterSubject() {
        return find(this.subjectMap, { id: this.cardLecture.subject_id }) || {};
      },

      cardSubjectName() {
        return this.filterSubject.name || '';
      },

      cardGrade() {
        return this.getTranslatedName(this.gradeMap[this.cardLecture.grade_id]) || this.$t('common.others');
      },

      cardViewsCount() {
        return this.cardLecture.view_count;
      },

    },

    methods: {
      viewCard(cardId) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: this.eventLabel,
          eventAction: 'click',
        });

        if (this.isCourseCard) {
          return this.$router.push(`/card/${cardId}?course_id=${this.courseId}`);
        }
        return this.$router.push(`/card/${cardId}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  %card-text {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.29;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.38);
  }

  .card {
    display: inline-block;
    width: 100%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.05);
    cursor: pointer;
    position: relative;

    &:hover {
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
    }
  
    .card-img-top {
      height: 148px;
      object-fit: fill;
    }

    .card-state-text {
      position: absolute;
      left: 0px;
      width: 48px;
      height: 20px;
      top: 0px;
      color: #ffffff;
      background-color: #00c896;
      z-index: 4;
      text-align: center;
    }


    .card-body {
      height: 156px;

      .card-title {
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-inline-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        max-height: 20px;
        word-break: break-all;
        white-space: normal;
      }

      .card-text-1 {
        @extend %card-text;
      }

      .card-text-2 {
        @extend %card-text;
      }

      .card-text-3 {
        @extend %card-text;
        font-weight: normal;
        padding-top: 14px;
      }

      .card-text-4 {
        @extend %card-text;
        font-weight: normal;
      }
    }
  }

  .list {
    width: 222px;
    margin: 14px 6px 14px 6px;
  }
</style>


// WEBPACK FOOTER //
// ImageCard.vue?523db6b8